const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPopupPiezo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 0.709537, -13.350261, -151.634186)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g27",
    transform: "translate(-79.826874,104.30828)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(29, 189, 200)",
      fillOpacity: 1
    },
    transform: "matrix(1.698573, 0, 0, 2.340009, -185.001083, -498.397736)",
    id: "g585-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path587-4",
    d: "m 171.12872,276.2113 v -9.525 h -3.57187 -3.57188 v -1.05833 -1.05834 h 4.63021 4.63021 v 4.49792 c 0,2.47385 0.10448,4.49792 0.23219,4.49792 0.1277,0 0.38256,-0.1812 0.56635,-0.40265 0.29515,-0.35563 0.37793,-0.34019 0.70886,0.13229 0.47981,0.68502 1.53041,0.68797 2.00834,0.006 l 0.37074,-0.52931 0.47902,0.52931 c 0.609,0.67294 1.24333,0.67294 1.85234,0 l 0.47901,-0.52931 0.37075,0.52931 c 0.47792,0.68234 1.52852,0.67939 2.00833,-0.006 0.33094,-0.47248 0.41371,-0.48792 0.70886,-0.13229 0.18379,0.22145 0.43865,0.40265 0.56635,0.40265 0.12771,0 0.23219,-2.02407 0.23219,-4.49792 v -4.49792 h 4.63021 4.63021 v 1.05834 1.05833 h -3.57188 -3.57187 v 9.525 9.525 h -7.40833 -7.40834 z",
    style: {
      fill: "#FFFFFF",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPopupPiezo);
export default __webpack_public_path__ + "static/media/map_popup_piezo.f240e53165fe8fae5e716136ebf88702.svg";
export { ForwardRef as ReactComponent };